var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logout"},[_c('img',{attrs:{"alt":"Vue logo","src":require("../assets/logo.png")}}),_c('span',[_vm._v("Logging out...")])])}]

export { render, staticRenderFns }